import PrimaryNavbar from "../../components/navigation/primary";

const Header = () => {

    return (
        <header>
            <PrimaryNavbar/>
        </header>
    );
    }

export default Header;